import { API_URL } from '../env';

export async function uploadFmcToken(token: string): Promise<void> {
    try {
        localStorage.setItem('fmc_token', token);
        const response = await fetch(`${API_URL}/api/v1/be/user/fcm-token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({ token }),
        });
        if (!response.ok) {
            //throw new Error('Failed to upload FMC token');
        }
    } catch (error) {
        console.error(error);
    }
}

export async function deleteFmcToken(): Promise<void> {
    try {
        const token = localStorage.getItem('fmc_token');
        if (!token) {   
            console.warn('No FMC token found in local storage');
            return;
        }
        const response = await fetch(`${API_URL}/api/v1/be/user/fcm-token`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({ token }),
        });
        if (!response.ok) {
            //throw new Error('Failed to delete FMC token');
        }
    } catch (error) {
        console.error(error);
        //throw error;
    }
}